document.addEventListener('alpine:init', () => {
  Alpine.data('offices', () => ({
    get visiblePopup() {
      return this._visiblePopup;
    },
    set visiblePopup(value) {
      if (value !== this._visiblePopup) {
        this.$dispatch('close-office-popups');
        this._visiblePopup = value;

        if (value) {
          this.calcPopupPosition();
          this.$store.bottomSheet.open('light', true);
        } else {
          this.$store.bottomSheet.close();
        }
      }
    },
    _visiblePopup: null,

    popupLeft: 0,

    calcPopupPosition() {
      const button = this.$root.querySelector(`[data-block-id="${this.visiblePopup}"]`);

      if (button) {
        const rect = button.getBoundingClientRect();

        if (rect.left + rect.width + 375 > window.innerWidth) {
          this.popupLeft = window.innerWidth - (rect.left + rect.width + 375);
        } else {
          this.popupLeft = rect.width;
        }
      }
    },
  }));
});